export function initializeTlaScript() {
  const isMobile = /iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  // Set global environment variable (before loading external script)
  window.__ENV__ = {
    API_URL: process.env.VUE_APP_BASE_SERVICE_DOMAIN || '',
  }
  if (!isMobile) {
    const scriptPath = './static/tro-ly-ao/tla.js' // should be placed in `public/static`

    const script = document.createElement('script')
    script.src = scriptPath
    // script.async = true
    document.head.appendChild(script)
  }
}



// WEBPACK FOOTER //
// ./src/utils/initializeTlaScript.js